<script>
  import {createEventDispatcher} from 'svelte';
  import {goto} from '@sapper/app';
  import {LINKS} from '@/const/link';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import Button from '@/widgets/Button.svelte';
  import Modal from '@/widgets/Modal.svelte';
  import lang from '../RegisterPage.lang';

  export let LG = null;
  export let type = null;

  const dispatch = createEventDispatcher();

  function handleCloseClick() {
    if (type === 'close') {
      dispatch('close');
      return;
    }
    dispatch('close');
    goto($fixLink$(PATHS.HOME.pathname));
  }
</script>

<style>
  .footer {
    margin: 40px auto 0;
  }
  .mt42 {
    margin-top: 42px;
  }
  .button {
    justify-content: flex-end;
  }
  @media screen and (max-width: 640px) {
    .button {
      justify-content: space-between;
    }
  }
</style>

<Modal visible>
  <div class="lh24 b f16 T2 df jcsb" slot="header">
    <div class="lh24 fw2 f18 T1">{LG(lang.RestrictedIP)}</div>
  </div>
  <div class="footer df fdc" slot="footer">
    <div>
      <div class="f14 t2 fw2 lh22">
        {LG(lang.Note)}
      </div>
      <div class="df button mt42">
        <Button type="primary" href={LINKS.PHEMEX_CUSTOMER_SERVICE} target="_blank" rel="noopener noreferrer nofollow">{LG(lang.ContactSupport)}</Button>
        <Button class="ml24" type="default" on:click={handleCloseClick}>Ok</Button>
      </div>
    </div>
  </div>
</Modal>
